module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <header class=\"col-12 d-flex justify-content-between\">\n      <div><a routerLink=\"/\">Francis Li</a></div>\n      <div><a class=\"btn btn-sm btn-outline-secondary\" href=\"mailto:mail@francisli.com\">Contact</a></div>\n    </header>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/header.component.html
// module id = 209
// module chunks = 1